var map = {
	"./facebook.svg": "6c61",
	"./instegram.svg": "77fe",
	"./linkedin.svg": "c115",
	"./pinterest.svg": "3251",
	"./twitter.svg": "3b97",
	"./youtube.svg": "57ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16cb";